export default __webpack_public_path__ + "static/media/nest.abd7771e.svg";